import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'ksnm-common-ui/lib/Table2';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import type { Filter } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { DesignLayout } from '@common/DesignLayout';
import { auditStore } from '@stores/auditStore';
import { constantStore } from '@stores/constantStore';
import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';

import { columns } from './columns';

const { TABLE_NAMES } = constantStore;

export const Audit = observer(() => {
  useEffect(() => {
    auditStore.getAllModules();
  }, []);

  const hardFilter = useMemo<Filter[][]>(
    () => [
      [
        {
          filterIsInverted: false,
          name: 'operation_source_service_name',
          type: FILTER.EQ,
          values: ['Audit'],
        },
      ],
    ],
    [],
  );

  return (
    <DesignLayout scrollEnable>
      <Table
        tableTitle="Аудит действий пользователей"
        tableName={TABLE_NAMES.AUDIT}
        hardFilter={hardFilter}
        columns={columns}
        resource="service.v_app_logs_tc"
        externalFetch={ksnmTableStore.externalFetch}
      />
    </DesignLayout>
  );
});
